module.exports = __webpack_public_path__ + "static/middleOfLastMovement-188340cd91feac28dd7ac709c2e3c80c.mp3";